var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73887 7.33892L11.1389 1.93892C11.2228 1.85501 11.2894 1.75539 11.3348 1.64575C11.3802 1.53611 11.4036 1.4186 11.4036 1.29992C11.4036 1.18125 11.3802 1.06374 11.3348 0.954098C11.2894 0.844458 11.2228 0.744837 11.1389 0.660923C11.055 0.577008 10.9553 0.510443 10.8457 0.465029C10.7361 0.419615 10.6185 0.39624 10.4999 0.39624C10.3812 0.39624 10.2637 0.419615 10.154 0.465029C10.0444 0.510443 9.94479 0.577008 9.86088 0.660923L5.09987 5.43092L2.13887 2.46092C1.9694 2.29145 1.73955 2.19624 1.49987 2.19624C1.2602 2.19624 1.03035 2.29145 0.860874 2.46092C0.691401 2.6304 0.596191 2.86025 0.596191 3.09992C0.596191 3.33959 0.691401 3.56945 0.860874 3.73892L4.46087 7.33892C4.54454 7.42328 4.64408 7.49023 4.75376 7.53592C4.86343 7.58162 4.98106 7.60514 5.09987 7.60514C5.21868 7.60514 5.33632 7.58162 5.44599 7.53592C5.55567 7.49023 5.65521 7.42328 5.73887 7.33892Z",
    fill: "url(#paint0_linear_683_30738)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_683_30738",
    x1: 0.596191,
    y1: 4.00069,
    x2: 11.4036,
    y2: 4.00069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.269122b84758480f6bed7e40b72c66bf.svg";
export { ForwardRef as ReactComponent };